export enum NormalizationFieldStatus {
	Default = 1,
	Advanced = 2
}
